/* ============ 恢复方式切换 ============ */
$('.recovery_mode').on('click', function () {
    var $mode = $(this);
    var target = $mode.attr('data-recovery');

    $('.recovery_mode').removeClass('active');
    $mode.addClass('active');

    $('.recovery_image').each(function () {
        var matches = $(this).attr('data-recovery-image') === target;
        $(this).toggleClass('active', matches);
    });
});

/* ============ 步骤轮播 ============ */
var $steps = $('.step');
var stepDuration = 5000;

function getActiveStepIndex() {
    var index = $steps.index($steps.filter('.active'));
    return index === -1 ? 0 : index;
}

function goToStep(index) {
    if(index>$steps.length-1){
        index=0
    }
    if(index<0){
        index=$steps.length-1
    }
    $steps.eq(index).addClass('active').siblings().removeClass('active');
    $('.steps_image div').eq(index).addClass('active').siblings().removeClass('active');
    $steps.find('i i').stop().css('width', 0);
    var $bar = $steps.eq(index).find('i i');
    $bar.animate({ width: $bar.parent().width() }, stepDuration , function () {
        goToStep(index + 1);
    });
}
$('.step').click(function(){
    goToStep($(this).index());
})
$('.steps_arrow_prev').on('click', function () {
    goToStep(getActiveStepIndex() - 1);
});

$('.steps_arrow_next').on('click', function () {
    goToStep(getActiveStepIndex() + 1);
});

goToStep(getActiveStepIndex());

/* ============ FAQ 折叠 ============ */
$('.faq_item').each(function () {
    var $item = $(this);
    var $question = $item.find('.faq_question');

    if (!$question.length) {
        return;
    }

    $question.on('click', function () {
        var isOpen = $item.hasClass('active');

        // 手风琴模式：关闭其它项
        $('.faq_item').removeClass('active');

        if (!isOpen) {
            $item.addClass('active');
        }
    });
});

// banner动画
$(function(){
    $('.hero_float_folder').addClass('active');
    $('.hero_float_photo').addClass('active');
    $('.hero_float_icloud').addClass('active');
    $('.hero_float_whatsapp').addClass('active');
    $('.hero_float_messages').addClass('active');
})
/* ============ 统计数据累加动画 ============ */
$(function () {
    var $stats = $('.hero_stats_inner');

    if (!$stats.length) {
        return;
    }

    var started = false;

    /* 解析 "98%" / "15M+" / "30-day" 这类数值文本 */
    function parseValue(text) {
        var match = text.match(/^(\d+(?:\.\d+)?)(.*)$/);

        if (!match) {
            return null;
        }

        return {
            target: parseFloat(match[1]),
            suffix: match[2],
            decimal: (match[1].split('.')[1] || '').length
        };
    }

    function animateValue($el) {
        var parsed = parseValue($el.text());

        if (!parsed) {
            return;
        }

        $({ current: 0 }).animate({ current: parsed.target }, {
            duration: 1600,
            easing: 'swing',
            step: function (now) {
                var value = parsed.decimal
                    ? now.toFixed(parsed.decimal)
                    : Math.round(now).toString();

                $el.text(value + parsed.suffix);
            },
            complete: function () {
                var value = parsed.decimal
                    ? parsed.target.toFixed(parsed.decimal)
                    : parsed.target.toString();

                $el.text(value + parsed.suffix);
            }
        });
    }

    function checkStats() {
        var statsTop = $stats.offset().top;
        var statsBottom = statsTop + $stats.outerHeight();
        var viewTop = $(window).scrollTop();
        var viewBottom = viewTop + $(window).height();

        /* 整个区块完整出现在视窗内后才开始动画 */
        if (statsTop >= viewTop && statsBottom <= viewBottom) {
            $stats.children('div').children('div').children('span:first-child').each(function () {
                animateValue($(this));
            });
            started = true;
            $(window).off('scroll resize', checkStats);
        }
    }

    checkStats();

    if (!started) {
        $(window).on('scroll resize', checkStats);
    }
});